let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fOkwy")).then(() => parcelRequire('zGZUa'));